var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({staticClass:"mb-2 h-28",class:{
    'bg-gray-200 dark:bg-gray-800': _vm.hasBg
  }},'div',_vm.$attrs,false),[_vm._t("default",null,{"blockClasses":_vm.blockClasses})],2)}
var staticRenderFns = []

export { render, staticRenderFns }